/**
 * Shared photo-lightbox math.
 *
 * One viewer on iOS, Android, web and tablets. The UI lives in
 * `components/ui/PhotoLightbox`; these helpers are the invariant that a
 * zoom step, a wheel tick or a wrap-around never leaves the image in an
 * unreachable scale or a missing index.
 */

export const PHOTO_LIGHTBOX_MIN_ZOOM = 1
export const PHOTO_LIGHTBOX_MAX_ZOOM = 4
export const PHOTO_LIGHTBOX_ZOOM_STEP = 0.5
export const PHOTO_LIGHTBOX_SWIPE_DISMISS_PX = 140

export function clampPhotoZoom(value: number): number {
  'worklet'
  if (!Number.isFinite(value)) return PHOTO_LIGHTBOX_MIN_ZOOM
  return Math.min(PHOTO_LIGHTBOX_MAX_ZOOM, Math.max(PHOTO_LIGHTBOX_MIN_ZOOM, value))
}

export function stepPhotoZoom(current: number, direction: 1 | -1): number {
  'worklet'
  return clampPhotoZoom(current + direction * PHOTO_LIGHTBOX_ZOOM_STEP)
}

export function zoomFromWheelDelta(current: number, deltaY: number): number {
  if (!Number.isFinite(deltaY) || deltaY === 0) return clampPhotoZoom(current)
  const factor = deltaY > 0 ? 0.9 : 1.1
  return clampPhotoZoom(current * factor)
}

export function clampPhotoIndex(length: number, index: number): number {
  if (length <= 0) return 0
  if (!Number.isFinite(index)) return 0
  return Math.min(length - 1, Math.max(0, Math.trunc(index)))
}

export function wrapPhotoIndex(length: number, index: number, delta: number): number {
  if (length <= 0) return 0
  const start = clampPhotoIndex(length, index)
  const shift = Number.isFinite(delta) ? Math.trunc(delta) : 0
  return (((start + shift) % length) + length) % length
}

export function shouldDismissPhotoLightbox(zoom: number, translationY: number): boolean {
  'worklet'
  return (
    clampPhotoZoom(zoom) <= PHOTO_LIGHTBOX_MIN_ZOOM + 0.02 &&
    translationY > PHOTO_LIGHTBOX_SWIPE_DISMISS_PX
  )
}
